import PropTypes from "prop-types";
import SanitizedContent from "../SanitizedContent";
import { CloseXIcon } from "../../lib/SvgComponents.jsx";

const ExpandedView = ({
  label,
  expanded,
  content,
  dismissable,
  collapseNotification,
}) => {
  return (
    <div className={`notification-banner-wrapper expanded-view`}>
      <div className="notification-banner-label">{label}</div>
      <div className="notification-banner-content qppds">
        <SanitizedContent
          html={expanded ? content : "<p>No notifications to display</p>"}
        />
      </div>
      {expanded && dismissable && (
        <button
          onClick={collapseNotification}
          type="button"
          className="notification-banner-close"
        >
          <svg className="close-icon" aria-hidden="true" focusable="false">
            <CloseXIcon />
          </svg>
          <span className="sr-only">Close</span>
        </button>
      )}
    </div>
  );
};

ExpandedView.propTypes = {
  label: PropTypes.string,
  expanded: PropTypes.bool,
  content: PropTypes.string,
  dismissable: PropTypes.bool,
  collapseNotification: PropTypes.func,
};

export default ExpandedView;
